import {
  /*reconvertEditorListsToRegularMarkup,*/ reconvertFromFlatToTreeList,
} from '../custom-extensions/PasteConverter/listConvertionUtils';

export const prepareContentForSending = (content) => {
  const fn = '[prepareContentForSending]:';
  console.debug(fn, 'preparing content:', content);
  // const result = reconvertEditorListsToRegularMarkup(content);
  const result = reconvertFromFlatToTreeList(content);
  return result;
};

export const processInternalLinks = (html) => {
  const appHost = process.env.REACT_APP_URL || window.location.host;

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html;
  const links = tempDiv.getElementsByTagName('a');

  for (let link of links) {
    try {
      const url = new URL(link.href);
      if (url.host === appHost) {
        const selectedTask = url.searchParams.get('selectedTask');
        if (selectedTask) link.innerHTML = selectedTask;
      }
    } catch (e) {
      continue;
    }
  }

  return tempDiv.innerHTML;
};

const imgUloadingInProgressRegexp = /<custom-img[^>]+file=/;
const hasImgRegexp = /<custom-img[^>]+fileid=[^>]+>/;

export const checkContentForUploadingImage = (content) =>
  imgUloadingInProgressRegexp.test(content);
export const checkContentForImages = (content) => hasImgRegexp.test(content);
